import PasswordResetCode from "@/features/password-reset/components/password-reset-code";
import PasswordResetForm from "@/features/password-reset/components/password-reset-form";
import useQueryParams from "@/hooks/use-query-params";
import { useState } from "react";

const PasswordResetRoute = () => {
  const { emailCode } = useQueryParams();
  const [showCode, setShowCode] = useState(false);
  const [email, setEmail] = useState<string | null>(null);

  if (showCode || emailCode) {
    return <PasswordResetCode email={email || ""} emailCode={emailCode || ""} />;
  }
  return (
    <PasswordResetForm
      onPasswordResetPetitionSuccess={email => {
        setEmail(email);
        setShowCode(true);
      }}
    />
  );
};

export default PasswordResetRoute;
